import { ITag } from "@common/redux/types/tags";
import _ from "lodash";

const DEFAULT_TITLE = 'Афиша мероприятий';

export const getEntitiesListTitle = (tags: ITag[], selectedTags: number[], defaultTitle = DEFAULT_TITLE): string => {
  let title = '';
  const tagNames = _(tags)
    .filter((value) => _.includes(selectedTags, value._id))
    .map('name')
    .value();

  if (tagNames.length > 3) {
    title = _(tagNames).slice(0, 3).join(', ') + ` + ${tagNames.length - 3}`;
  } else {
    title = tagNames.join(', ');
  }

  return title || defaultTitle;
}
